<template>
  <div class="news">
    <div class="inner-content">
      <Alert></Alert>

      <div class="news-list mt-5">
        <v-row>
          <Card
            v-for="article in news"
            :key="article.ID"
            :title="article.title.rendered"
            :date="article.date"
            :image="article.thumbnail"
            :link="{ name: 'article', params: {slug: decodeURIComponent(article.slug)} }"
          ></Card>
        </v-row>
      </div>

      <Pagination v-model="page"></Pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Alert from '@/components/Utils/Alert.vue'
import Card from '@/components/Card.vue'
import Pagination from '@/components/Utils/Pagination.vue'

export default {
  name: 'NewsList',
  components: { Pagination, Alert, Card },
  data () {
    return { page: 1 }
  },

  mounted () {
    this.fetchNews()
  },

  methods: {
    fetchNews () {
      this.$store.commit('setLoading', true)
      this.$store.dispatch('getNews', { page: this.page }).then(() => {
        this.$store.commit('setLoading', false)
      }).catch(() => {
        this.$store.commit('setLoading', false)
        this.$store.commit('showAlert', { type: 'error', message: 'Грешка при зареждането на новините.' })
      })
    }
  },

  computed: mapGetters(['news', 'loading']),

  watch: {
    page: 'fetchNews'
  }
}
</script>

<style lang="scss">
.article-preview {
  width: 100%;
}
</style>
